<template>
    <CompassDialog
        :visible.sync="showModal"
        size="large"
        :title="$t.__('AddressMap.map_and_route')"
        class="address-map"
        @closed="$emit('close')"
    >
        <template slot="default">
            <div class="dialog__default">
                <div class="dialog__default--formcontainer">
                    <!-- ROUTING FORM -->
                    <section class="mb-4">
                        <!-- ORIGIN INPUT-->
                        <div class="label-input">
                            <label for="">{{ $l10n.__('Définissez un point de départ') }}</label>
                            <algolia-input
                                :default-value="startPoint"
                                element-name="algolia-address"
                                place-type="address"
                                @bubble-address="captureAddress"
                            ></algolia-input>
                        </div>

                        <!-- DESTINATION SELECT -->
                        <div class="label-input">
                            <label for="">{{ $l10n.__("Définissez un point d'arrivée") }}</label>
                            <el-select
                                v-model="endAddressId"
                                class="wp-10"
                                :placeholder="$t.__('AddressMap.arrival_point')"
                            >
                                <el-option
                                    v-for="(address, index) in availableAddresses"
                                    :key="index"
                                    :label="address.name"
                                    :value="address.id"
                                >
                                </el-option>
                            </el-select>
                        </div>

                        <!-- START BUTTON -->
                        <div class="mt-4">
                            <CompassButton
                                :label="$t.__('common.actions.search')"
                                :disabled="!availableAddresses.length > 0"
                                @click="startRouting()"
                            />
                        </div>
                    </section>

                    <!-- ADDRESSES CARDS-->
                    <h3 class="mt-0">{{ $l10n.__('Adresse(s) de la société') }}</h3>
                    <div class="ov-auto">
                        <address-map-card
                            v-for="(address, index) in addresses"
                            ref="addressCard"
                            :key="index"
                            :address="address"
                            @select-address="selectAddress"
                        />
                    </div>
                </div>
                <div class="dialog__default--map">
                    <jawg-map
                        ref="jawgMap"
                        :addresses="addresses"
                        :selectedAddress="selectedAddress"
                        :origin="startPoint"
                        :destination="endPoint"
                    />
                </div>
            </div>
        </template>
    </CompassDialog>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import AddressMapCard from './AddressMapCard.vue';
import JawgMap from './JawgMap.vue';
import AlgoliaInput from './inputs/AlgoliaInput.vue';
import IconSvg from 'vcomponents/icons/IconSvg.vue';
import IconSellsyCloud from 'vcomponents/icons/IconSvgLogoSellsyCloud.vue';

export default {
    components: {
        'address-map-card': AddressMapCard,
        'jawg-map': JawgMap,
        'algolia-input': AlgoliaInput,
        IconSvg,
        IconSellsyCloud,
    },
    props: {
        visible: {
            type: Boolean,
        },
        addresses: {
            type: Array,
        },
        corpAddress: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            showModal: this.visible,
            selectedAddress: {},
            endPoint: '',
            startPoint: '',
            endAddressId: '',
        };
    },
    computed: {
        availableAddresses() {
            return this.addresses.filter((address) => address.lat !== null && address.lng !== null);
        },
    },
    watch: {
        visible(newValue) {
            this.showModal = newValue;
        },
    },
    mounted() {
        this.selectedAddress =
            this.availableAddresses.find((address) => address.isMainInvoicingAddress) ||
            this.availableAddresses.find((address) => address.isMainDeliveryAddress) ||
            this.availableAddresses.find((address) => address.lat !== null && address.lng !== null);
        this.startPoint =
            this.corpAddress == undefined
                ? ''
                : this.corpAddress.part1 + ', ' + this.corpAddress.town;
        this.endAddressId = this.selectedAddress.id;
    },
    methods: {
        selectAddress(address, el) {
            for (let i = 0; i < this.$refs.addressCard.length; i++) {
                this.$refs.addressCard[i].selected = false;
            }
            el.selected = true;
            this.endAddressId = address.id;
            this.selectedAddress = address;
            this.$refs.jawgMap.setZoom(address);
        },
        startRouting() {
            if (this.availableAddresses.length > 0) {
                this.selectedAddress = this.availableAddresses.find(
                    (address) => address.id == this.endAddressId,
                );
                this.endPoint = this.selectedAddress.part1 + ', ' + this.selectedAddress.town;
                this.$nextTick(() => {
                    this.$refs.jawgMap.startRouting();
                });
            }
        },
        captureAddress(data) {
            this.startPoint = data.label;
        },
    },
};
</script>

<style lang="scss">
.address-map {
    .dialog {
        &__default {
            display: flex;
            justify-content: space-between;
            padding-bottom: 24px;

            &--formcontainer {
                width: 304px;
                margin-right: 16px;
            }

            &--map {
                width: 100%;
                height: 600px;
            }
        }
    }
}
</style>
